import { Dispatch, SetStateAction } from "react";
import { FormControlLabel } from "@material-ui/core";
import { IFieldValuesBE } from "..";
import { SwitchBlue } from "../../../../../../../libs/switch";
import Input from "../../../../../../../components/Input";

type IPJCost = {
  fieldsValue: IFieldValuesBE;
  setFieldValue: Dispatch<SetStateAction<IFieldValuesBE>>;
  paidVacation: string;
  corporationId: number;
  equipaments: boolean;
  setEquipaments: Dispatch<SetStateAction<boolean>>;
};

export function PJCost({ fieldsValue, setFieldValue, paidVacation, corporationId, equipaments, setEquipaments }: IPJCost) {
  return (
    <>
      {corporationId === 1 && (
        <div className="box-row">
          <Input
            className="form-input"
            label="Descanso Remunerado"
            name="descanso"
            placeholder="Descanso remunerado do PJ"
            value={paidVacation}
            disabled
          />
        </div>
      )}
      <div className="box-row row-equipaments">
        <div className="flex row-equipaments__box">
          <FormControlLabel
            className="switch display-inline switch-cost"
            control={<SwitchBlue checked={equipaments} onChange={() => setEquipaments(!equipaments)} name="checkedB" />}
            labelPlacement="start"
            label="Equipamentos"
          />
        </div>
        <Input
          type={equipaments ? "number" : "text"}
          className="row-equipaments__input form-input"
          label="Valor do equipamento(s)"
          name="equipaments"
          placeholder="Valor do equipamento(s)"
          value={equipaments ? fieldsValue?.equipments : "Valor do equipamento(s)"}
          setValue={(e: any) =>
            setFieldValue({
              ...fieldsValue,
              equipments: e.target.value,
            })
          }
          disabled={!equipaments}
        />
      </div>
    </>
  );
}
